export default __webpack_public_path__ + "static/media/121.4f2675e0.webp";